import { ApplicationRootState } from './../../types/index';
import { getShelvesWithPositions, PositionShelf } from './helpers';
import { createSelector } from 'reselect';
import { ContainerState } from './types';
import { initialState } from './reducer';
import { makeSelectCabinet } from 'containers/Configurator/selectors/furniture';
import {
  makeSelectConfiguratorMode,
  makeSelectPaintHandlesMode,
} from '../ModeBar/selectors';
import { ConfiguratorMode, HandlesMode } from '../ModeBar/reducer';
import {
  makeSelectPaintMaterialHandles,
  makeSelectPaintTypeHandles,
} from '../HandlesPanel/selectors';
import {
  DoorHandleType,
  DrawerHandleType,
  Material,
} from '../../lib/modelBuilder/constants';

const selectViewerDomain = (state: ApplicationRootState) =>
  state.viewer || initialState;

export const makeSelectShelvesWithPositions = () =>
  createSelector(makeSelectCabinet(), (cabinet): PositionShelf[] => {
    if (cabinet) return getShelvesWithPositions(cabinet);
    return [];
  });

/**
 * Handles:
 *  doors
 *  slat-wood
 *  slat-alu
 */
export const makeSelectCursor = () =>
  createSelector(
    makeSelectConfiguratorMode(),
    makeSelectPaintHandlesMode(),
    makeSelectPaintTypeHandles(),
    makeSelectPaintMaterialHandles(),
    (mode, handlesMode, type, material): string => {
      if (mode === ConfiguratorMode.handles) {
        if (handlesMode === HandlesMode.doors) {
          if (type === DoorHandleType.Button) {
            return 'doors-button';
          } else if (type === DoorHandleType.BigButton) {
            return 'doors-big-button';
          } else if (type === DoorHandleType.Knop) {
            return 'doors-knop';
          }
        } else if (handlesMode === HandlesMode.bigShelves) {
          if (material === Material.Wood) {
            return 'slat-wood';
          } else if (material === Material.Aluminium) {
            return 'slat-alu';
          }
        } else if (handlesMode === HandlesMode.drawers) {
          switch (type) {
            case DrawerHandleType.Knop:
              return 'drawers-knop';
            case DrawerHandleType.Button:
              return 'drawers-button';
            case DrawerHandleType.Slat:
              return 'drawers-slat';
            case DrawerHandleType.Eco:
              return 'drawers-eco';
            case DrawerHandleType.EcoPlus:
              return 'drawers-eco-plus';
          }
        }
      }
      return mode;
    },
  );
